//  need refactoring all errors messages are hardcoded
export default [
  {
    type: 'required',
    message: 'This field is required'
  },
  {
    type: 'email',
    message: 'This field should contain a valid email'
  },
  {
    type: 'slug',
    message: 'This field should contain a valid slug'
  },
  {
    type: 'minValue',
    message: 'This field should be bigger than 0'
  },
  {
    type: 'maxValue',
    message: 'This field should be less than 100'
  },
  {
    type: 'url',
    message: 'This field should contain a valid url'
  },
  {
    type: 'between',
    message: 'This field should be between 0.1 and 100'
  },
  {
    type: 'digitsCountBetween',
    message: 'This field should be between 9 and 12'
  },
  {
    type: 'numeric',
    message: 'This field should contain only numerics'
  },
  {
    type: 'number',
    message: 'This field should contain only numerics'
  },
  {
    type: 'alpha',
    message: 'This field should contain only latin letters'
  },
  {
    type: 'maxLength',
    message: 'This field is too long'
  },
  {
    type: 'vatId',
    message: 'This field should contain 2 caps letter and numerics'
  },
  {
    type: 'phoneNumberValidation',
    message: 'This field should contain "+" on the start and only numerics before'
  },
  {
    type: 'fontSizeValidation',
    message: 'This field should contain font size value from 1 to 36'
  },
  {
    type: 'nameValidation',
    message: 'This field should contain latin letters and "-","\'"'
  }
]



// WEBPACK FOOTER //
// ./src/modules/error-messages.js